var devices = {
    smallDevice: 1024,
};
export default devices;
